<template>
  <div>
    <StepTitle :name="stepData.name" />
    <transition name="faderooms" mode="out-in">
      <div v-if="showState === 'code'" class="code-form" key="coderoom">
        <SubTextTitle>Vul hier de code in</SubTextTitle>
        <CodeForm :on-sendit="proceed" class="form" />
      </div>
      <div v-else-if="showState === 'video'" key="videoroom">
        <div class="video-player">
          <img
            width="100%"
            height="100%"
            :src="stepData.img"
            alt="correct-code"
            class="ie-replacement"
          />
          <div
            class="mychannels"
            data-mychannels-type="video"
            data-mychannels-id="162829"
            data-mychannels-options="TUFFU_default"
          />
        </div>
        <SubTextContainer>
          <SubTextTitle>Fantastisch! Je hebt de code gekraakt</SubTextTitle>
          <span>
            Het is je gelukt om de code te kraken. <br
        class="em_hide"
      />Laat je gegevens achter en misschien maak jij dan kans op een prijs.
          </span>
        </SubTextContainer>
      </div>
      <div
        class="data-container"
        v-else-if="showState === 'form'"
        key="dataroom"
      >
        <SubTextContainer>
          <SubTextTitle>Vul je gegevens in</SubTextTitle>
          <span>
            Je bent er bijna! Laat hier je gegevens achter, vul de schiftingsvraag in <br
        class="em_hide"
      />en misschien maak jij kans op een Code Van Coppens-bordspel.
          </span>
        </SubTextContainer>
        <JouwForm />
        <ErrorMessage v-if="errors && errors.connection">
          Er liep iets mis tijdens het verzenden, gelieve opnieuw te proberen.
        </ErrorMessage>
        <ErrorMessage v-if="errors">
          <ul class="error-list">
            <li v-for="text in mapErrorsToText" :key="text">
              {{ text }}
            </li>
          </ul>
        </ErrorMessage>
        <SubTextContainer />
      </div>
      <div v-else-if="showState === 'mail'" key="mailroom">
        <SubTextContainer class="win-state">
          <Icon name="check" size="40" />
          <span
            >Hou je mailbox in de gaten. Iedere week selecteren we de winnaars.</span
          >
        </SubTextContainer>
      </div>
      <div v-else-if="showState === 'fail'" key="failroom">
        <div class="video-player">
          <img width="100%" height="100%" :src="stepData.img" />
          <div class="overlay">
            <Icon name="smiley" size="30%" />
          </div>
        </div>
        <SubTextContainer>
          <SubTextTitle>Helaas, de kluis is al leeggeroofd</SubTextTitle>
          <span>Deze wedstrijd is al afgelopen. Kraak de code van de meest recente kamer <br
        class="em_hide"
      />en maak zo toch nog kans op een spelbord van De Code van Coppens.</span>
        </SubTextContainer>
      </div>
    </transition>
    <div class="buttons">
      <transition name="faderooms" mode="out-in">
        <Button @click.native="proceed" v-if="showState === 'code'">
          Bevestig de code <Icon name="cta" size="9" />
        </Button>
        <Button @click.native="proceed" v-else-if="showState === 'video'">
          Grabbel in de kluis <Icon name="cta" size="9" />
        </Button>
        <Button @click.native="proceed" v-else-if="showState === 'form'">
          Verstuur mijn gegevens <Icon name="cta" size="9" />
        </Button>
        <Button @click.native="proceed" v-else-if="showState === 'mail'">
          Terug naar kameroverzicht <Icon name="cta" size="9" />
        </Button>
        <Button @click.native="proceed" v-else-if="showState === 'fail'">
          Naar de wedstrijd <Icon name="cta" size="9" />
        </Button>
      </transition>
    </div>
    <SubTextContainer v-if="showState === 'code'">
      <a href="#" @click="resetStep">Terug naar Kameroverzicht</a>
    </SubTextContainer>
  </div>
</template>

<script>
import StepTitle from '@/components/StepTitle';
import { mapMutations, mapState } from 'vuex';
import SubTextTitle from '@/components/SubTextTitle';
import Button from '@/components/Button';
import SubTextContainer from '@/components/SubTextContainer';
import CodeForm from '@/components/forms/CodeForm';
import JouwForm from '@/components/forms/JouwForm';
import ErrorMessage from '@/components/ErrorMessage';
import { validateFields } from '@/helpers/validate-fields';
import Icon from '@/components/Icon';

export const errorMap = {
  senderGender: 'Aanspreking',
  senderFirstname: 'Voornaam',
  senderLastname: 'Achternaam',
  senderEmail: 'Email',
  bevestigEmail: 'Bevestiging e-mail',
  schiftingsVraag: 'Jouw antwoord',
};

export default {
  name: 'Kamer',
  components: {
    Icon,
    ErrorMessage,
    JouwForm,
    CodeForm,
    SubTextContainer,
    Button,
    SubTextTitle,
    StepTitle,
  },
  computed: {
    ...mapState([
      'stepData',
      'hasWon',
      'showForm',
      'fail',
      'checkMail',
      'errors',
      'jouwData',
    ]),
    showState() {
      let result = 'code';
      if (this.hasWon) {
        result = 'video';
      }
      if (this.showForm) {
        result = 'form';
      }
      if (this.fail) {
        result = 'fail';
      }
      if (this.checkMail) {
        result = 'mail';
      }

      return result;
    },
    mapErrorsToText() {
      const errorArray = [];
      Object.keys(this.errors).forEach(errorKey => {
        if (this.errors[errorKey] && this.errors[errorKey].length) {
          errorArray.push(`Controleer het ${errorMap[errorKey]} veld`);
        }
      });

      return errorArray;
    },
  },
  methods: {
    ...mapMutations([
      'resetStep',
      'checkCode',
      'proceedToForm',
      'sendData',
      'setErrors',
      'sayFail',
      'setStep',
      'setNavigateFlag',
    ]),
    proceed() {
      if (this.showState === 'code') {
        this.checkCode();
      } else if (this.showState === 'video') {
        if (this.stepData.isFinished) {
          this.sayFail();
        } else {
          this.proceedToForm();
        }
      } else if (this.showState === 'form') {
        const errors = validateFields(this.jouwData);
        if (!errors.errors) {
          this.setErrors({ errors: null });
          this.sendData();
        } else {
          this.setErrors({ errors: errors.errors });
        }
      } else if (this.showState === 'fail') {
        this.resetStep();
        this.setNavigateFlag();
      } else {
        this.resetStep();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.code-form {
  padding-top: 25px;

  .form {
    padding-top: 35px;
  }
}
.video-player {
  height: auto;
  width: 100%;
  max-width: 680px;
  min-height: 383px;
  max-height: 383px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;

  margin: 30px auto 0;

  @media print, screen and (max-width: 550px) {
    min-height: 50vw;
    max-height: 50vw;
  }

  padding: 0;
  background-color: black;

  > img.ie-replacement {
    display: none;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .video-player {
    > div.mychannels {
      display: none;
    }

    > img.ie-replacement {
      display: block;
    }
  }
}

.data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.error-list {
  text-align: left;
}
.buttons {
  padding-bottom: 25px;
}
.win-state {
  padding-top: 20px;
  padding-bottom: 20px;
  > img {
    margin-bottom: 40px;
  }
}
.overlay {
  top: 0;
  background-color: rgba(200, 200, 200, 0.7);
  position: absolute;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  pointer-events: none;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.faderooms-enter-active,
.faderooms-leave-active {
  transition: opacity 0.2s;
}
.faderooms-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
